module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('br'), _c('br'), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "fm"
    }
  }), _c('em', [_vm._v("List of Figures")])]), _vm._v(" "), _c('p', {
    staticClass: "listpara"
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGURE")]), _vm._v(" 1. Cover Illustration. The Eiffel Tower was surrounded by water when the Seine flooded the Champs-de-Mars.")]), _vm._v(" "), _c('p', {
    staticClass: "listparaa"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURCE")]), _vm._v(": Charles Eggimann, ed., "), _c('em', [_vm._v("Paris inondé: la crue de janvier 1910")]), _vm._v(" (Paris: Editions du Journal des Débats, 1910). Courtesy of W.T. Bandy Collection, Jean and Alexander Heard Library, Vanderbilt University.")]), _vm._v(" "), _c('p', {
    staticClass: "listpara"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9780230617063_01_tit#fig2"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGURE")]), _vm._v(" 2. Frontispiece. Map of the flooded area in January–February 1910.")])]), _vm._v(" "), _c('p', {
    staticClass: "listparaa"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURCE")]), _vm._v(": Commission des Inondations, "), _c('em', [_vm._v("Rapports et documents divers")]), _vm._v(" (Paris: Imprimerie Nationale, 1910).")]), _vm._v(" "), _c('p', {
    staticClass: "listpara"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9780230617063_06_pro#fig3"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGURE")]), _vm._v(" 3. Prologue. The flooded courtyard of the Palais Bourbon, home of the National Assembly.")])]), _vm._v(" "), _c('p', {
    staticClass: "listparaa"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURCE")]), _vm._v(": Charles Eggimann, ed., "), _c('em', [_vm._v("Paris inondé: la crue de janvier 1910")]), _vm._v(" (Paris: Editions du Journal des Débats, 1910). Courtesy of W.T. Bandy Collection, Jean and Alexander Heard Library, Vanderbilt University.")]), _vm._v(" "), _c('p', {
    staticClass: "listpara"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9780230617063_07_int#fig4"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGURE")]), _vm._v(" 4. Introduction. Parisians measured the height of floods on the bodies of the statues on the Pont de l’Alma, especially that of the Zouave.")])]), _vm._v(" "), _c('p', {
    staticClass: "listparaa"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURCE")]), _vm._v(": Author’s personal collection.")]), _vm._v(" "), _c('p', {
    staticClass: "listpara"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/9780230617063_09_ch01#fig5"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGURE")]), _vm._v(" 5. Chapter One. Rescue efforts, including boats and ladders, helped Parisians escape the rising water in their homes.")])]), _vm._v(" "), _c('p', {
    staticClass: "listparaa"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURCE")]), _vm._v(": Author’s personal collection.")]), _vm._v(" "), _c('p', {
    staticClass: "listpara"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9780230617063_10_ch02#fig6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGURE")]), _vm._v(" 6. Chapter Two. Parisians established wooden walkways, called "), _c('em', [_vm._v("passerelles")]), _vm._v(", so they could continue to move about the city during the high water.")])]), _vm._v(" "), _c('p', {
    staticClass: "listparaa"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURCE")]), _vm._v(": Charles Eggimann, ed., "), _c('em', [_vm._v("Paris inondé: la crue de janvier 1910")]), _vm._v(" (Paris: Editions du Journal des Débats, 1910). Courtesy of W.T. Bandy Collection, Jean and Alexander Heard Library, Vanderbilt University.")]), _vm._v(" "), _c('p', {
    staticClass: "listpara"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9780230617063_10_ch02#fig7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGURE")]), _vm._v(" 7. Chapter Two. Streets were ripped up, sometimes exposing the foundations of buildings.")])]), _vm._v(" "), _c('p', {
    staticClass: "listparaa"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURCE")]), _vm._v(": Author’s personal collection.")]), _vm._v(" "), _c('p', {
    staticClass: "listpara"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9780230617063_11_ch03#fig8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGURE")]), _vm._v(" 8. Chapter Three. In the Javel neighborhood, an elderly woman, rescued by the police, hangs onto a makeshift raft for dear life.")])]), _vm._v(" "), _c('p', {
    staticClass: "listparaa"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURCE")]), _vm._v(": Charles Eggimann, ed., "), _c('em', [_vm._v("Paris inondé: la crue de janvier 1910")]), _vm._v(" (Paris: Editions du Journal des Débats, 1910). Courtesy of W.T. Bandy Collection, Jean and Alexander Heard Library, Vanderbilt University.")]), _vm._v(" "), _c('p', {
    staticClass: "listpara"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/9780230617063_11_ch03#fig9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGURE")]), _vm._v(" 9. Chapter Three. Photographers, like those from the studio of Pierre Petit, captured the strange beauty of a city filled with water.")])]), _vm._v(" "), _c('p', {
    staticClass: "listparaa"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURCE")]), _vm._v(": Pierre Petit, "), _c('em', [_vm._v("Paris inondé, janvier 1910: 32 vues")]), _vm._v(" (Paris: Pierre Petit, 1910). Courtesy of W.T. Bandy Collection, Jean and Alexander Heard Library, Vanderbilt University.")]), _vm._v(" "), _c('p', {
    staticClass: "listpara"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9780230617063_13_ch04#fig10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGURE")]), _vm._v(" 10. Chapter Four. First responders and city workers lined the quay walls with sandbags and stones to hold back the water’s force.")])]), _vm._v(" "), _c('p', {
    staticClass: "listparaa"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURCE")]), _vm._v(": Charles Eggimann, ed., "), _c('em', [_vm._v("Paris inondé: la crue de janvier 1910")]), _vm._v(" (Paris: Editions du Journal des Débats, 1910). Courtesy of W.T. Bandy Collection, Jean and Alexander Heard Library, Vanderbilt University.")]), _vm._v(" "), _c('p', {
    staticClass: "listpara"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9780230617063_13_ch04#fig11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGURE")]), _vm._v(" 11. Chapter Four. A little girl is steadied by police as she crosses a narrow walkway to be reunited with her father.")])]), _vm._v(" "), _c('p', {
    staticClass: "listparaa"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURCE")]), _vm._v(": Author’s personal collection.")]), _vm._v(" "), _c('p', {
    staticClass: "listpara"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9780230617063_14_ch05#fig12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGURE")]), _vm._v(" 12. Chapter Five. The interior of the Gare d’Orsay became a favorite for photographers who focused on the light-filled archway inside the central hall. The electrified tracks sat under several feet of water.")])]), _vm._v(" "), _c('p', {
    staticClass: "listparaa"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURCE")]), _vm._v(": Charles Eggimann, ed., "), _c('em', [_vm._v("Paris inondé: la crue de janvier 1910")]), _vm._v(" (Paris: Editions du Journal des Débats, 1910). Courtesy of W.T. Bandy Collection, Jean and Alexander Heard Library, Vanderbilt University.")]), _vm._v(" "), _c('p', {
    staticClass: "listpara"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9780230617063_15_ch06#fig13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGURE")]), _vm._v(" 13. Chapter Six. Shelters run by the Red Cross, the Catholic church, and the government housed thousands of Parisians forced out of their homes by high water.")])]), _vm._v(" "), _c('p', {
    staticClass: "listparaa"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURCE")]), _vm._v(": André Taride, ed., "), _c('em', [_vm._v("Paris et ses environs")]), _vm._v(" (Paris: A. Taride, 1910). Courtesy of W.T. Bandy Collection, Jean and Alexander Heard Library, Vanderbilt University.")]), _vm._v(" "), _c('p', {
    staticClass: "listpara"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9780230617063_17_ch07#fig14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGURE")]), _vm._v(" 14. Chapter Seven. Women begin the arduous process of disinfection in the Rue de la Convention in the 15th "), _c('em', [_vm._v("arrondissement")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "listparaa"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURCE")]), _vm._v(": Charles Eggimann, ed., "), _c('em', [_vm._v("Paris inondé: la crue de janvier 1910")]), _vm._v(" (Paris: Editions du Journal des Débats, 1910). Courtesy of W.T. Bandy Collection, Jean and Alexander Heard Library, Vanderbilt University.")]), _vm._v(" "), _c('p', {
    staticClass: "listpara"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9780230617063_17_ch07#fig15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGURE")]), _vm._v(" 15. Chapter Seven. Looters threatened lives and property, especially in the hard-hit suburban areas, but some Parisians took matters into their own hands to fight back.")])]), _vm._v(" "), _c('p', {
    staticClass: "listparaa"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURCE")]), _vm._v(": Author’s personal collection.")]), _vm._v(" "), _c('p', {
    staticClass: "listpara"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9780230617063_18_ch08#fig16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGURE")]), _vm._v(" 16. Chapter Eight. Government leaders were very visible during the flood, bringing comfort and assistance to the city’s residents. Police prefect Louis Lépine points with his cane to show President Armand Fallières the damage.")])]), _vm._v(" "), _c('p', {
    staticClass: "listparaa"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURCE")]), _vm._v(": Charles Eggimann, ed., "), _c('em', [_vm._v("Paris inondé: la crue de janvier 1910")]), _vm._v(" (Paris: Editions du Journal des Débats, 1910). Courtesy of W.T. Bandy Collection, Jean and Alexander Heard Library, Vanderbilt University.")]), _vm._v(" "), _c('p', {
    staticClass: "listpara"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9780230617063_19_ch09#fig17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGURE")]), _vm._v(" 17. Chapter Nine. The cover of "), _c('em', [_vm._v("Le Petit Journal Illustré")]), _vm._v(" offered a stirring allegory blending Marianne, the symbol of France, and Geneviève, the patron saint of Paris, to show both urban and national solidarity in the midst of disaster.")])]), _vm._v(" "), _c('p', {
    staticClass: "listparaa"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURCE")]), _vm._v(": Author’s personal collection.")]), _vm._v(" "), _c('p', {
    staticClass: "listpara"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/9780230617063_20_epi#fig18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGURE")]), _vm._v(" 18. Epilogue. In November 1910 when the river began to rise again, anxious Parisians watched the water level on a newly installed gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "listparaa"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURCE")]), _vm._v(": "), _c('em', [_vm._v("L’Illustration")]), _vm._v(", November 19, 1910. Author’s personal collection.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74874a3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780230617063_05_list.vue
// module id = 72
// module chunks = 0